import EditButtonSubscription from './EditButtonSubscription';

export default EditButtonSubscription;
